import React, { useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { getReportCategory } from "../../../../graphql/queries";
import { updateReportCategory } from "../../../../graphql/mutations";
import SimpleCreateEdit from "../../../Common/Crud/SimpleCreateEdit";
import TextInput from "../../../../components/Common/TextInput";
import * as ReportCategoriesConstants from "../../../../graphql/Constants/ReportCategories/Types";
import nameChangeHandler from "../../../Common/Crud/formHandlers/nameChangeHandler";
import orderChangeHandler from "../../../Common/Crud/formHandlers/orderChangeHandler";
import nameOnlyFormsValidationHandler from "../../../Common/Crud/formHandlers/nameOnlyFormsValidationHandler";
import * as CrudActionTypes from "../../../../constants/Crud/ActionTypes";

const ReportCategoryEdit = (props) => {
  // states
  const [name, setName] = useState("");
  const [order, setOrder] = useState(0);
  const [inputFieldsDisable, setInputFieldsDisable] = useState(false);
  const [errors, setErrors] = useState({});
  const [updateButtonDisableStatus, setUpdateButtonDisableStatus] = useState(
    false
  );

  //#region update ReportCategory business logic
  const handleUpdateReportCategory = async () => {
    try {
      // initial required ReportCategory update data
      let input = {
        id: props.match.params.reportCategoryId,
        name: name.trim(),
        order: order
      };

      await API.graphql(graphqlOperation(updateReportCategory, { input }));
      return { result: true, message: `ReportCategory updated successfully` };
    } catch (error) {
      return {
        result: false,
        message: `Error updating ReportCategory, ${JSON.stringify(error, null, 2)}`,
      };
    }
  };
  //#endregion

  return (
    <SimpleCreateEdit
      {...props}
      crudActionType={CrudActionTypes.Edit}
      returnHandler={() => props.history.push(`/reportCategories`)}
      modelName="Report Category"
      getModelMethod={async () => {
        let result = await API.graphql(
          graphqlOperation(getReportCategory, { id: props.match.params.reportCategoryId })
        );
        if (result) {
          setName(result.data.getReportCategory.name);
          setOrder(result.data.getReportCategory.order);
        }
        return result.data.getReportCategory;
      }}
      // createOrUpdateDisableMethod={(modelData) => {
      //   if (modelData.id === ReportCategorysConstants.Other.id) return true;
      //   return false;
      // }}
      // createOrUpdateDisabledActions={() => {
      //   setNameInputTextDisable(true);
      // }}
      formSubmissionHandler={handleUpdateReportCategory}
      formValidationHandler={() =>
        nameOnlyFormsValidationHandler(
          name,
          "ReportCategory",
          false, // we need to exclude the OTHER
          setUpdateButtonDisableStatus,
          setErrors
        )
      }
      setErrorsState={() => setErrors}
      actionButtonDisabledState={updateButtonDisableStatus}
    >
      <TextInput
        type="name"
        id="name"
        label="Report Category Name"
        placeholder="Enter a Report Category name"
        value={name}
        onChange={(e) =>
          nameChangeHandler(
            e,
            "ReportCategory",
            false, // we need to exclude the OTHER,
            setName,
            setUpdateButtonDisableStatus,
            setErrors
          )
        }
        isRequired={true}
        error={errors.name}
        disabled={inputFieldsDisable}
      />
      <TextInput
        type="number"
        id="order"
        label="Report Category Order"
        placeholder="Enter a Report Category Order"
        value={order}
        onChange={(e) =>
          orderChangeHandler(
            e,
            "ReportCategory",
            setOrder,
            setUpdateButtonDisableStatus,
            setErrors
          )
        }
        isRequired={true}
        error={errors.order}
        disabled={inputFieldsDisable}
      />
    </SimpleCreateEdit>
  );
};

export default ReportCategoryEdit;
